import { createSlice } from '@reduxjs/toolkit';
import { fetchAlerts } from '../thunks/alerts';

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        alert: [],
    },
    reducers: {
        setAlertData: (state, action) => {
            state.alert = action.payload;
        },

        deleteAlertData: (state, action) => {
            state.alert = state.alert.filter(alert => alert.id !== action.payload);
        },

        saveAlertData: (state, action) => {
            state.alert.push(action.payload);
        },
        updateAlertData: (state, action) => {
            state.alert = state.alert.map(alert =>
                alert.id === action.payload.id ? action.payload : alert
            );
        },
    }, extraReducers: (builders) => {
        builders.addCase(fetchAlerts.fulfilled, (state, action) => {
            state.alert = action.payload;
        })
    }
});

export const { setAlertData, deleteAlertData, saveAlertData, updateAlertData } = alertSlice.actions;
export default alertSlice.reducer;
